import { useEffect, useState } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import styles from "./S6_ActivationStep3.module.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  LinearProgressBarCust,
  TextFieldCust,
  ButtonCust,
  PopperCust,
  CustToolTip,
} from "../../../widgets";
import { useAppDispatch } from "../../../../app/hooks";
import ActivationPayNow from "./PayNow";
import { PayFailureModal } from "./PayFailureModal";
import { ActivationManageCard } from "./ManageCard";
import { PhoneNoPattern } from "../../../../utils/regexPatterns";
import {
  gaCategory,
  gaEvents,
  gaScreenNames,
} from "../../../../Types/GoogleAnalytics";
import { ActivationFailedModal } from "../ActivationStep4/ActivationFailedModal";
import { HelpSupportModal } from "../ActivationStep2/SupportModal";
import EsimPaymentSuccess from "./EsimPaymentSuccess";
import Config from "../../../../config/env.config.json";
import { CarrierTypes } from "../../../../enums";
import { InternalBanner } from "../../../common";
import { CustToolTip_T2 } from "../../../widgets/TooltipCust_T2";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  BrandNameUpdate,
  gtmTagManager,
  renderTextStyles,
} from "../../../../utils";
import ActivationLoader from "./ActivationLoader";

const T6_ActivationStep3 = (props: any) => {
  const {
    currentLine,
    content,
    modalContent,
    step4Content,
    GAAndFBEventsHandler,
    formik,
    displayContent,
    loader,
    payNowConfirm,
    payLoader,
    showActModal,
    payNowFailModal,
    payNowFailedModal,
    handleBack,
    openEsimPaySuccess,
    onCloseEsimPaySuccess,
    activateUser,
    actBtnLoader,
    activationLoaderContent,
    miaPaymentCheckDone,
    showPaymentLoader,
    paymentAmount,
  } = props;
  let customerDetails: any = localStorage?.getItem("customerDetail");
  customerDetails = JSON.parse(customerDetails);
  const dispatch = useAppDispatch();
  const [showCardChangeModal, setShowCardChangeModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openSupportDialog, setOpenSupportDialog] = useState(false);
  const { sp3_title, step_txt, sim_check, msgs, simId_length, sim_instr } =
    content;
  const [iccidTargetAnchorEl, setIccidTargetAnchorEl] = useState(null);
  const [openICCIDInstructionPopper, setOpenICCIDInstructionPopper] =
    useState<boolean>(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (showActModal) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [showActModal]);

  const manageCardFg = () => {
    setShowCardChangeModal(true);
  };

  const showCardChangeModalHandle = () => {
    setShowCardChangeModal(false);
  };
  const closeActivationFailModal = () => {
    setShowModal(false);
  };
  const openSupportModal = () => {
    setShowModal(false);
    setOpenSupportDialog(true);
  };
  const onCloseSupportDialog = () => {
    setOpenSupportDialog(false);
    if (!openEsimPaySuccess) {
      setShowModal(true);
    }
  };
  const onClickICCIDInfoIcon = async (e: any) => {
    setOpenICCIDInstructionPopper(true);
    setIccidTargetAnchorEl(e.target);
  };
  const onCloseInfoDlg = () => {
    setOpenICCIDInstructionPopper(false);
    setIccidTargetAnchorEl(null);
  };
  return (
    <>
      {/* <InternalBanner
        pageName={"MyAccount"}
        apiEndPoint={"myAccBanner"}
        type={"internal"}
      /> */}
      <Box
        sx={{
          cursor: "pointer",
          width: "18px",
          height: "18px",
          zIndex: "100",
          left: "0",
          position: "absolute",
          ml: { md: "30px", sm: "25px", xs: "25px" },
          mt: { md: "60px" },
          display: { xs: "none", sm: "inline-block" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "18px",
            height: "18px",
            position: "absolute",
            left: "3rem",
            alignItems: "center",
          }}
          onClick={handleBack}
        >
          <ArrowBackIosIcon sx={{ width: "18px", fontSize: "1.125rem" }} />
          <Box
            sx={{
              fontFamily: "var(--font_family_Medium)",
              fontWeight: "var(--font_weight_1)",
              fontSize: "18px",
              lineHeight: "30px",
            }}
          >
            Back
          </Box>
        </Box>
      </Box>
      <KeyboardBackspaceIcon
        fontSize="large"
        onClick={handleBack}
        sx={{
          display: { xs: "block", sm: "none" },
          position: "absolute",
          top: "91.5px",
          left: "20px",
          color: "var(--internal_back_arrow_color, var(--white))",
        }}
      />
      <Box className={styles.step3_main}>
        {/* <Box className={styles.heading_container}>
          <ArrowBackIcon
            sx={{ ml: { md: "30px", sm: "25px", xs: "4%" } }}
            className={styles.arrow_icon}
            onClick={handleBack}
          />
        </Box> */}

        {displayContent === "main" && (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: { xs: "92%", sm: "724px" },
                mx: "auto",
              }}
            >
              <Paper
                sx={{
                  // border: "1px solid rgba(0,0,0,.2)",
                  width: { sm: "724px" },
                  // height: "600px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mt: { xs: "40px", sm: "60px" },
                  boxShadow: { xs: "unset !important" },
                  marginBottom: "45px",
                  // px: { xs: "12px", md: "unset" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: { xs: "25px 0px" },
                  }}
                >
                  {/* <Box
                    component="img"
                    alt={"circular_loader"}
                    src={content?.icc_id_icon?.data?.attributes?.url}
                    sx={{ width: { xs: "33px", paddingRight: "16px" } }}
                  /> */}
                  <Typography
                    sx={{
                      fontSize: { xs: "18px", sm: "24px" },
                      fontFamily: "var(--font_family_Bold)",
                      textAlign: "center",
                      fontWeight: "var(--font_weight_4)",
                      color: "var(--black)",
                      lineHeight: { xs: "30px", sm: "36px" },
                    }}
                  >
                    {sp3_title}
                  </Typography>
                </Box>
                <Box sx={{ width: "100%", textAlign: "center" }}>
                  <Divider
                    style={{ border: "1px solid var(--lightgrey_6)" }}
                  ></Divider>
                </Box>
                <Typography
                  className={styles.stepper_txt}
                  sx={{
                    fontFamily: "var(--font_family_Semibold)",
                    color: "var(--text_color)",
                    pt: "14px",
                  }}
                >
                  {!currentLine?.esim && sim_check?.step_txt_sim
                    ? sim_check?.step_txt_sim
                    : content?.step_txt}
                </Typography>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontFamily: "var(--font_family_Regular)",
                      fontWeight: "var(--font_weight_0)",
                      color: "var(--text_color)",
                      mt: { xs: "22px" },
                      mb: { xs: "30px" },
                    }}
                  >
                    {currentLine?.isPrimary
                      ? BrandNameUpdate(sim_check?.desc)
                      : BrandNameUpdate(sim_check?.desc_sec) ||
                        BrandNameUpdate(sim_check?.desc)}
                  </Typography>
                </Box>
                <Box
                  width={{ xs: "90%", sm: "80%", md: "69%" }}
                  sx={{ mx: { xs: "12px" } }}
                >
                  <TextFieldCust
                    value={formik.values.simId}
                    name="simId"
                    onChange={(e: any) => {
                      const maxLength =
                        Config.OPERATOR.toLowerCase() === CarrierTypes.ATT ||
                        Config.OPERATOR.toUpperCase() === CarrierTypes.VERIZON
                          ? 20
                          : 19;

                      if (
                        (PhoneNoPattern.test(e.target.value) ||
                          e.target.value === "") &&
                        e.target.value.length <= maxLength
                      ) {
                        formik.setFieldValue(e.target.name, e.target.value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    type={window.screen.width <= 600 ? "number" : "text"}
                    label={sim_check?.sim_ph}
                    maxLength={
                      Config.OPERATOR.toLowerCase() === CarrierTypes.ATT ||
                      Config.OPERATOR.toUpperCase() === CarrierTypes.VERIZON
                        ? 20
                        : 19
                    }
                    error={
                      formik.touched?.simId && formik.errors?.simId
                        ? true
                        : false
                    }
                    helperText={formik.touched?.simId && formik.errors?.simId}
                    onKeyUp={(e: any) => {
                      if (e.key === "Enter") {
                        formik.handleSubmit();
                      }
                    }}
                  />

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    marginY={"8px"}
                  >
                    <Box display="flex" alignItems="center">
                      <Typography
                        sx={{
                          fontSize: "12px",
                          marginRight: "4px",
                          fontFamily: "var(--font_family_Regular)",
                          color: "var(--text_color)",
                        }}
                        className={styles.step3_info}
                      >
                        {content?.where_to_find_txt}
                      </Typography>
                      <CustToolTip_T2
                        open={open}
                        enterTouchDelay={0}
                        title={
                          <Typography
                            sx={{
                              // color: "var(--subtext_color)",
                              fontSize: "13px",
                              lineHeight: "18px",
                              padding: "15px",
                              fontFamily: "var(--font_family_Regular)",
                              fontWeight: "var(--font_weight_1)",
                              textAlign: "center",
                              color: "var(--text_color)",
                            }}
                          >
                            <Box
                              component="img"
                              src={
                                content?.sim_check?.sim_instr?.data?.attributes
                                  ?.url
                              }
                              alt={
                                content?.sim_check?.sim_instr?.data?.attributes
                                  ?.alternativeText
                              }
                              width="250px"
                              height="150px"
                            />
                            {content?.help_txt}
                          </Typography>
                        }
                        disableFocusListener
                        disableHoverListener
                        placement="bottom-start"
                        arrow
                    
                      >
                        <Box
                          component="img"
                          src={content?.info_icon?.data?.attributes?.url}
                          alt={
                            content?.info_icon?.data?.attributes
                              ?.alternativeText
                          }
                          onClick={() => setOpen(true)}
                          onMouseEnter={() => {
                            setOpen(true);
                          }}
                          onMouseLeave={() => {
                            setOpen(false);
                          }}
                          sx={{
                            width: "14px",
                            height: "14px",
                          }}
                        />
                      </CustToolTip_T2>
                    </Box>
                    <Typography
                      className={styles.step3_limit_div}
                      sx={renderTextStyles(
                        4,
                        "12px",
                        "black",
                        "25px",
                        "var(--font_weight_0)"
                      )}
                    >
                      {formik.values.simId.length}
                      {simId_length}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ margin: "15px 0px 30px" }}>
                  <Box className={styles.step3_btn}>
                    <ButtonCust
                      variantType={Config.PRIMARY_BUTTON_TYPE}
                      disabled={
                        formik.values?.simId?.length === 0
                          ? true
                          : !formik?.isValid
                      }
                      onClick={() => {
                        formik.handleSubmit();
                        GAAndFBEventsHandler(
                          gaCategory.activation,
                          sim_check?.check_btn
                        );
                        gtmTagManager({
                          event: gaEvents?.fillSimICCD,
                          screen_name: gaScreenNames?.activation,
                        });
                      }}
                      sx={{ width: "250px" }}
                      loading={loader}
                    >
                      {sim_check?.check_btn}
                    </ButtonCust>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </>
        )}
        {displayContent === "pay" &&
          (showPaymentLoader ? (
            <ActivationLoader
              content={activationLoaderContent}
              miaPaymentCheckDone={miaPaymentCheckDone}
              paymentAmount={paymentAmount}
            />
          ) : (
            <ActivationPayNow
              payNowConfirm={payNowConfirm}
              payBtnLoader={payLoader}
              manageCardFg={manageCardFg}
              content={content}
              {...props}
              displayContent={displayContent}
            />
          ))}
        <ActivationManageCard
          showCardChangeModal={showCardChangeModal}
          setShowCardChangeModal={showCardChangeModalHandle}
          isModalRequired={true}
        />
        {payNowFailModal && (
          <PayFailureModal
            modalFg={payNowFailModal}
            closeHandler={() => payNowFailedModal(false)}
            content={content}
          />
        )}
        {showModal && (
          <ActivationFailedModal
            showModal={showModal}
            openSupportModal={openSupportModal}
            closeActivationFailModal={closeActivationFailModal}
            content={step4Content}
            currentLine={currentLine}
          />
        )}
        <HelpSupportModal
          open={openSupportDialog}
          onClose={() => onCloseSupportDialog()}
          title={step4Content?.c_sup_title}
          showClose={false}
          showBackBtn={true}
          content={modalContent}
        />
        <EsimPaymentSuccess
          open={openEsimPaySuccess}
          onClose={() => onCloseEsimPaySuccess()}
          activateUser={activateUser}
          openSupportModal={openSupportModal}
          actBtnLoader={actBtnLoader}
          content={content}
        />
      </Box>
    </>
  );
};
export default T6_ActivationStep3;
